<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :rules="rules"
      :disabled="disabled"
      :model="formData"
    >
      <el-descriptions class="mb-4" :column="12" size="medium" border>
        <el-descriptions-item :label="$l('form_label_amzGoodsSkuNo')" :span="6">
          {{ formData.amzGoodsSkuNo }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_amzBrandName')" :span="6">
          {{ formData.amzBrandName }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_amzCollectionNameAll')"
          :span="6"
        >
          {{ formData.amzCollectionName }}/{{ formData.amzCollectionNameCn }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_amzCategoryFullName')"
          :span="6"
        >
          {{ formData.amzCategoryFullName }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_amzGoodsName')" :span="6">
          {{ formData.amzGoodsName }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_amzGoodsNameEn')"
          :span="6"
        >
          {{ formData.amzGoodsNameEn }}
        </el-descriptions-item>

        <el-descriptions-item
          :label="$l('form_label_unitGoodsSize')"
          content-class-name="content-unit-weight"
          :span="5"
        >
          {{ formData.unitGoodsSize }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_amzUnitWeight')"
          content-class-name="content-unit-weight"
          :span="4"
        >
          {{ formData.amzUnitWeight }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_amzGoodsProperties')"
          content-class-name="content-unit-weight"
          :span="3"
        >
          {{ formData.amzGoodsProperties }}
        </el-descriptions-item>
      </el-descriptions>
      <div class="d-flex">
        <div class="side-frame-success">
          <span style="font-size: 16px; color: #606266">
            {{ $l('form_label_amzStore') || '店铺' }}：{{ formData.storeName }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 16px; color: #606266">
            {{ $l('form_label_region') || '市场' }}：{{ formData.regionName }}
          </span>
          <el-divider direction="vertical"> </el-divider>
          <el-tag
            size="mini"
            effect="dark"
            :type="
              formData.storeSkuStatus === 'Y'
                ? 'success'
                : formData.storeSkuStatus === 'S' ||
                  formData.storeSkuStatus === 'B' ||
                  formData.storeSkuStatus === 'W'
                ? 'danger'
                : formData.storeSkuStatus === 'X'
                ? 'warning'
                : ''
            "
          >
            {{ formData.v_storeSkuStatus || '未配置状态' }}
          </el-tag>
          <el-divider direction="vertical"> </el-divider>
          <span style="font-size: 16px; color: #606266">
            Modify：{{ formData.modifyByName }} at {{ formData.modifyDate }}
          </span>
        </div>
      </div>
      <el-row :gutter="10" type="flex" justify="space-between">
        <el-col>
          <el-form-item
            :label="$l('table_label_amzSkuNo') || '亚马逊SKU编号'"
            prop="amzSkuNo"
          >
            <el-input
              v-model="formData.amzSkuNo"
              clearable
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            :label="$l('table_label_asinCode') || 'ASIN'"
            prop="asinCode"
          >
            <el-input
              v-model="formData.asinCode"
              maxlength="50"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            :label="$l('table_label_fnskuCode') || 'FNSKU'"
            prop="fnskuCode"
          >
            <el-input
              v-model="formData.fnskuCode"
              maxlength="50"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item :label="$l('form_label_upc') || 'UPC'">
            <el-input
              v-model="formData.upc"
              maxlength="50"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            :label="$l('form_label_operate') || '运营人员'"
            prop="operateCode"
          >
            <dict-select
              v-model="formData.operateCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.operateName"
              clearable
              filterable
              style="width:100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="10">
          <el-form-item
            :label="$l('table_label_salesGoodsName') || '店铺售卖名称'"
            prop="salesGoodsName"
          >
            <el-input
              v-model="formData.salesGoodsName"
              clearable
              maxlength="500"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('table_label_brand') || '品牌'"
            prop="brandCode"
          >
            <dict-select
              clearable
              v-model="formData.brandCode"
              :selectedLabel.sync="formData.brandName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              url="/master/common/dict/brandSelect"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_salesPrice') || '正常卖价'"
            prop="salesPrice"
          >
            <el-input-number
              controls-position="right"
              style="width: 100%"
              size="small"
              :min="0"
              :step="0.01"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :precision="4"
              v-model="formData.salesPrice"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_salesCurrencyUnit') || '卖价货币单位'"
            prop="salesCurrencyUnit"
          >
            <dict-select
              size="small"
              clearable
              filterable
              v-model="formData.salesCurrencyUnit"
              :body="currencyUnitParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('table_label_salesTitle') || '店铺售卖标题'"
            prop="salesTitle"
          >
            <el-input
              v-model="formData.salesTitle"
              clearable
              maxlength="1000"
              type="textarea"
              rows="2"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            :label="$l('table_label_salesDesc') || '销售描述'"
            prop="salesDesc"
          >
            <el-input
              v-model="formData.salesDesc"
              clearable
              maxlength="1000"
              type="textarea"
              rows="2"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('table_label_salesUrl') || '售卖Url地址'">
            <el-input v-model="salesUrl" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.form_label_unitLength') || '单品包装长(cm)'"
            prop="unitLength"
          >
            <el-input-number
              v-model="formData.unitLength"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="2"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.form_label_unitWidth') || '单品包装宽(cm)'"
            prop="unitWidth"
          >
            <el-input-number
              v-model="formData.unitWidth"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="2"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.form_label_unitHeight') || '单品包装高(cm)'"
            prop="unitHeight"
          >
            <el-input-number
              v-model="formData.unitHeight"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="2"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.form_label_unitWeight') || '单品包装重量(kg)'"
            prop="unitWeight"
          >
            <el-input-number
              v-model="formData.unitWeight"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_goodsProperties') || '产品属性'"
            prop="goodsProperties"
          >
            <dict-select
              v-model="formData.goodsProperties"
              url="/master/common/dict/biz"
              :body="{ dictType: 'goodsProperties' }"
              :selectedLabel.sync="formData.goodsProperties"
              clearable
              disabled
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item :label="$l('form_label_fbaDeliveryFee') || 'FBA配送费'">
            <el-input-number
              v-model="formData.fbaDeliveryFee"
              :step="1"
              :min="0"
              :precision="2"
              controls-position="right"
              style="width:100%"
              v-el-inputnumber-default0
            />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('form_label_noMoreReplenishment') || '是否补货'"
          >
            <el-input v-model="formData.noMoreReplenishment" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$l('form_label_isFocus') || '是否重点关注'">
            <el-input v-model="formData.isFocus" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- fbaDeliveryFee -->
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    storeCode: { type: String, default: '' },
    amzSkuStoreCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      chooseAmzSkuVisible: false,
      skuTableData: [],
      currencyUnitParams: { dictType: 'currencyUnit' },
      rules: {
        amzSkuNo: [
          {
            required: true,
            trigger: 'blur',
            message:
              this.$l('form_placeholder_amzSkuNo') || '请输入亚马逊SKU编号',
          },
        ],
        asinCode: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('form_placeholder_asinCode') || '请输入ASIN',
          },
        ],
        fnskuCode: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('form_placeholder_fnskuCode') || '请输入FNSKU',
          },
        ],
        operateCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        salesPrice: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('form_placeholder_salesPrice') || '请输入正常卖价',
          },
          {
            type: 'number',
            min: 0.1,
            message:
              this.$l('form_placeholder_correct_salesPrice') ||
              '请输入正确的正常卖价',
          },
        ],
        salesCurrencyUnit: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('form_placeholder_salesCurrencyUnit') ||
              '请选择卖价货币单位',
          },
        ],
        unitLength: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_unitLength') ||
              '请输入单品包装长',
            trigger: 'blur',
          },
        ],
        unitWidth: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_unitWidth') || '请输入单品包装宽',
            trigger: 'blur',
          },
        ],
        unitHeight: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_unitHeight') ||
              '请输入单品包装高',
            trigger: 'blur',
          },
        ],
        unitWeight: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_unitWeight') ||
              '请输入单品包装重量',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    salesUrl() {
      const { salesUrl, asinCode } = this.formData
      if (!salesUrl) return ''
      return salesUrl.replace(/\/[^/]+$/, '/' + asinCode)
    },
  },
  methods: {
    init() {
      if (!this.storeCode || !this.amzSkuStoreCode) return
      this.$api
        .ecomAmzSkuListingDetailViewApi({
          storeCode: this.storeCode,
          amzSkuStoreCode: this.amzSkuStoreCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async validate() {
      const formResult = await validate.formValidate([this.$refs.form])
      return formResult
    },
    async save(checked = true) {
      if (!(await this.validate())) return (this.backDialogVisible = false)

      const params = { ...this.formData, checked }
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSkuListingSaveViewApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res || {}
      if (status === 203) {
        const confirm = await this.$confirm(`<span style="color: red;">${msg}</span> &nbsp;是否要继续保存？`,
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_save') || '保存',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }
        )
          .then(() => true)
          .catch(() => false)
        if (!confirm) return
        await this.save(false)
        return
      }
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
::v-deep {
  .el-descriptions-item__label {
    width: 129px !important;
  }
  .content-unit-weight {
    width: 200px !important;
  }
}
</style>
